var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetProfileConvertHistoryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00098 11.6059V13.758C3.00084 14.3232 3.11205 14.8829 3.32825 15.4051C3.54445 15.9273 3.8614 16.4018 4.261 16.8015C4.66061 17.2012 5.13504 17.5182 5.6572 17.7346C6.17936 17.9509 6.73901 18.0622 7.30421 18.0622H20.2139M3.00098 6.22656H15.9107C16.4759 6.22643 17.0357 6.33767 17.558 6.55393C18.0803 6.77019 18.5548 7.08724 18.9545 7.48695C19.3542 7.88666 19.6713 8.36121 19.8875 8.88349C20.1038 9.40576 20.215 9.96553 20.2149 10.5308V12.6819",
    stroke: "#FF592E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9868 14.8346L20.215 18.0618L16.9868 21.29M6.22818 9.45535L3 6.22717L6.22818 3",
    stroke: "#FF592E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetProfileConvertHistoryIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_profile_convert_history_icon.85b17c601735868a1d85172113e4c622.svg";
export { ForwardRef as ReactComponent };